import { capitalizeFirstLetter } from '@axo/shared/util/string';
import range from 'lodash/range';

import { IMonthsOptions } from './DateDropdown';

export const getDate = (year: number, month: number) => {
  return new Date(Date.UTC(year, month, 1)).toJSON();
};

export function generateYearOptions(
  min: number,
  max: number,
  latestYearAtTop: boolean,
  minYearSuffix?: string,
  maxYearSuffix?: string
) {
  const yearOptions = range(min, max + 1).map((year) => ({
    text: year.toString(),
    value: year,
  }));

  if (minYearSuffix) {
    yearOptions[0].text += ` ${minYearSuffix}`;
  }
  if (maxYearSuffix) {
    yearOptions[yearOptions.length - 1].text += ` ${maxYearSuffix}`;
  }

  return latestYearAtTop ? yearOptions.reverse() : yearOptions;
}

export function generateMonthsOptions(i18n: string): IMonthsOptions {
  const monthOptions = range(0, 12).map((month) => ({
    text: capitalizeFirstLetter(
      new Date(Date.UTC(1970, month, 1)).toLocaleDateString(i18n, {
        month: 'long',
      })
    ),
    value: month,
  }));

  return monthOptions;
}

interface FilterMonths {
  months: IMonthsOptions;
  year: number;
  filter: 'future' | 'past';
}

export const filterMonths = ({ months, year, filter }: FilterMonths) => {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  if (currentYear !== year) return months;

  const newMonths =
    filter === 'past'
      ? months.slice(0, currentMonth + 1)
      : months.slice(currentMonth);

  return newMonths;
};

export const getMonthWithFallback = (
  months: IMonthsOptions,
  selectedMonth: number | undefined,
  fallback: number
) => {
  return months.some((e) => e.value === selectedMonth)
    ? selectedMonth
    : fallback;
};
